import axios from 'axios'

import { formatDateForServer, parseDateFromServer } from '../../../functions/dateHandling'

import { getServerUrl } from '../../../functions/getServerUrl'

import {
  savingChartPhase,
  errorSavingChartPhase,
  alertChartHasBeenSaved,
  errorSavingChartDate,
 } from './chartFormReducer'


const defaultState = {
  patientDied: false,
  patientDischarged: false,
  dateOfDeath: null,
  causesOfDeath: '',
  place_of_residence: '',
  place_of_residence_other_text: '',
  dateOfDischarge: null,
  dischargedWithAntibiotics: false,

  hospitalizationOutcomeUrl: '',
}


export default function hospitalizationOutcomeFormReducer(state = defaultState, action) {
  switch (action.type) {
    case "HANDLE_HOSPITALIZATION_OUTCOME_FORM_FIELD_CHANGE":
      return { ...state, [action.payload.key]: action.payload.value }
    case "HOSPITALIZATION_OUTCOME_TOGGLE_PATIENT_DIED_OR_DISCHARGED":
      const portionOfChartToReset = getStateForPatientDiedOrDischarged(action.payload.patientDied, action.payload.patientDischarged)
      return { ...state, ...portionOfChartToReset }
    case "CHART_HOSPITALIZATION_OUTCOME_INFO_HAS_BEEN_SAVED":
      return { ...state, hospitalizationOutcomeUrl: action.payload.hospitalizationOutcomeUrl }
    case "SET_CHART_FROM_SERVER_TO_FORM":
      const hospitalizationOutcome = resetHopitalizationOutcomeFromServer(action.payload)
      return {
        ...state,
        ...hospitalizationOutcome,
      }
    case "MARK_CHART_AS_COMPLETED":
      return defaultState
    case "CHART_HAS_BEEN_DELETED":
      return defaultState
    default:
      return state
  }
}


export const handleHospitalizationOutcomeChartFieldChange = (key, value) => {
  return { type: "HANDLE_HOSPITALIZATION_OUTCOME_FORM_FIELD_CHANGE", payload: { key, value } }
}


const chartHospitalizationOutcomeHasBeenSaved = (hospitalizationOutcomeUrl, goToNextPhase) => {
  return {
    type: "CHART_HOSPITALIZATION_OUTCOME_INFO_HAS_BEEN_SAVED",
    payload: { hospitalizationOutcomeUrl, goToNextPhase },
  }
}

export const togglePatientDiedorDischarged = (patientDied, patientDischarged) => {
  return {
      type: "HOSPITALIZATION_OUTCOME_TOGGLE_PATIENT_DIED_OR_DISCHARGED",
      payload: { patientDied, patientDischarged },
    }
}

const getStateForPatientDiedOrDischarged = (patientDied, patientDischarged) => {
  if (patientDied === true) {
    return {
      patientDied: true,
      patientDischarged: false,
      dateOfDischarge: null,
      place_of_residence: '',
      place_of_residence_other_text: '',
      dischargedWithAntibiotics: false,
    }
  } else if (patientDischarged === true) {
    return {
      patientDischarged: true,
      patientDied: false,
      dateOfDeath: null,
      causesOfDeath: '',
    }
  } else {
    return {
      patientDischarged: false,
      patientDied: false,
    }
  }
}


export const submitChartHospitalizationOutcome = (props, goToNextPhase) => {

  const { hospitalizationOutcomeUrl } = props

  return (dispatch, getState) => {
    const chartIsSaving = getState().chartFormReducer.savingChartPhase
    if (chartIsSaving) {
      return dispatch({ type: '' })
    }

    dispatch(savingChartPhase())

    const hospitalizationOutcome = formatHopitalizationOutcomeForServer(props)
    let method, url

    if (hospitalizationOutcomeUrl) {
      method = "PATCH"
      url = hospitalizationOutcomeUrl
    } else {
      method = "POST"
      url = `${getServerUrl()}/hospitalization-outcomes/`
    }

    axios({
      method,
      url,
      headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
      data: hospitalizationOutcome,
    })
    .then(response => {
      alertChartHasBeenSaved(props)
      dispatch(chartHospitalizationOutcomeHasBeenSaved(response.data.url))
    })
    .catch(error => {
      if (error.response && error.response.data.non_field_errors) {
        let joinError = error.response.data.non_field_errors.join(' ')
        let firstKey = joinError.split('[')[1].split(',')[0]
        if (joinError.split('[')[1].includes(',')) {
          let secondKey = joinError.split('[')[1].split(',')[1].split(']')[0].split(' ')[1]
          if (hospitalizationOutcome[`${firstKey}`]) {
            let firstArr = firstKey.split('_')
            let firstJoined = firstArr.map(key => key.charAt(0).toUpperCase() + key.slice(1)).join('')
            let firstCamelCase = firstJoined.charAt(0).toLowerCase() + firstJoined.slice(1)
            if (props.chartDateErrorMessage === firstCamelCase) {
              props[`${firstCamelCase}`] = null
              dispatch(submitChartHospitalizationOutcome(props))
              dispatch(handleHospitalizationOutcomeChartFieldChange(firstCamelCase, null))
            }
          }
          if (hospitalizationOutcome[`${secondKey}`]) {
            let secondArr = secondKey.split('_')
            let secondJoined = secondArr.map(key => key.charAt(0).toUpperCase() + key.slice(1)).join('')
            let secondCamelCase = secondJoined.charAt(0).toLowerCase() + secondJoined.slice(1)
            if (props.chartDateErrorMessage === secondCamelCase) {
              props[`${secondCamelCase}`] = null
              dispatch(submitChartHospitalizationOutcome(props))
              dispatch(handleHospitalizationOutcomeChartFieldChange(secondCamelCase, null))
            }
          }
        } else {
          let arr = firstKey.split('_')
          let joined = arr.map(key => key.charAt(0).toUpperCase() + key.slice(1)).join('')
          let camelCase = joined.charAt(0).toLowerCase() + joined.slice(1).split(']')[0]
          if (props.chartDateErrorMessage === camelCase) {
            props[`${camelCase}`] = null
            dispatch(submitChartHospitalizationOutcome(props))
            dispatch(handleHospitalizationOutcomeChartFieldChange(camelCase, null))
          }
        }
        return dispatch(errorSavingChartDate(error, "Hospitalization Outcome"))
    } else {
      return dispatch(errorSavingChartPhase(error, "Hospitalization Outcome", dispatch))
    }
  })
  }
}


const formatHopitalizationOutcomeForServer = (props) => {
  return {
    patient_died: props.patientDied,
    patient_discharged: props.patientDischarged,
    patient_chart: props.patientChartUrl,
    date_of_death: formatDateForServer(props.dateOfDeath),
    causes_of_death: props.causesOfDeath,
    date_of_discharge: formatDateForServer(props.dateOfDischarge),
    place_of_residence: props.place_of_residence || null,
    place_of_residence_other_text: props.place_of_residence_other_text || null,
    discharged_with_antibiotics: props.dischargedWithAntibiotics,
  }
}

const resetHopitalizationOutcomeFromServer = (patientChart) => {
  if (!patientChart.hospitalization_outcome) {
    return {}
  }

  const hospitalizationOutcome = patientChart.hospitalization_outcome

  return {
    patientDied: hospitalizationOutcome.patient_died,
    patientDischarged: hospitalizationOutcome.patient_discharged,
    dateOfDeath: parseDateFromServer(hospitalizationOutcome.date_of_death),
    causesOfDeath: hospitalizationOutcome.causes_of_death || '',
    dateOfDischarge: parseDateFromServer(hospitalizationOutcome.date_of_discharge),
    place_of_residence: hospitalizationOutcome.place_of_residence || '',
    place_of_residence_other_text: hospitalizationOutcome.place_of_residence_other_text || '',
    dischargedWithAntibiotics: hospitalizationOutcome.discharged_with_antibiotics,
    hospitalizationOutcomeUrl: hospitalizationOutcome.url,
  }
}
